/**
 *
 *  RESIZED WINDOW finished :  timeout so fn.windowResizeEvent only triggered once resizing stops
 */
var waitForFinalEvent = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if (!uniqueId) {
			uniqueId = "Don't call this twice without a uniqueId";
		}
		if (timers[uniqueId]) {
			clearTimeout (timers[uniqueId]);
		}
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();


$(window).resize(function () {
	
	$('html').addClass('resizing');
	
	waitForFinalEvent(function(){
		// onWindowResize();
		$('html').removeClass('resizing');
		$( document ).trigger( "windowResizeEvent" ); // set custom event

	}, 500, "some unique string");
});